import * as yup from 'yup';
import UtilityService from '../../services/UtilityService';
import { CustomFieldContract } from '../../types/CustomField';
import {
  getOptionalStringValidator,
  getRequiredStringValidator,
} from './Generators';

export const getCustomFieldsSchema = (
  customFields: CustomFieldContract[]
): yup.ObjectSchema => {
  return yup.object().shape(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    customFields.reduce((previousValue: any, field) => {
      const schema = {
        ...previousValue,
      };
      const name = UtilityService.buildCustomFieldInputName(field);
      const isRequired = field.isRequired.toUpperCase() === 'Y';
      switch (field.inputType.toUpperCase()) {
        case 'TEXTBOX':
          schema[name] = (
            isRequired
              ? getRequiredStringValidator()
              : getOptionalStringValidator()
          ).max(
            field.maxLength,
            `Field cannot be longer than ${field.maxLength} characters.`
          );
          break;
        case 'DROPDOWN':
          schema[name] = getOptionalStringValidator();
          break;
        case 'CHECKBOX':
          if (isRequired) {
            schema[name] = getRequiredStringValidator().test(
              'requiredCheck',
              'You must check this box',
              value => !!value && value !== 'false'
            );
          } else {
            schema[name] = getOptionalStringValidator();
          }
          break;
        default:
      }
      return schema;
    }, {})
  );
};

export const getCustomFieldsSchemaWithFormContext = (
  customFields: CustomFieldContract[]
): yup.ObjectSchema => {
  return yup.object().shape(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    customFields.reduce((previousValue: any, field) => {
      const schema = {
        ...previousValue,
      };
      const name =
        UtilityService.buildCustomFieldInputNameWithFormContext(field);
      const isRequired = field.isRequired.toUpperCase() === 'Y';

      switch (field.inputType.toUpperCase()) {
        case 'TEXTBOX':
          schema[name] = (
            isRequired
              ? getRequiredStringValidator()
              : getOptionalStringValidator()
          ).max(
            field.maxLength,
            `Field cannot be longer than ${field.maxLength} characters.`
          );
          break;
        case 'DROPDOWN':
          schema[name] = getOptionalStringValidator();
          break;
        case 'CHECKBOX':
          if (isRequired) {
            schema[name] = getRequiredStringValidator().test(
              'requiredCheck',
              'You must check this box',
              value => !!value && value !== 'false'
            );
          } else {
            schema[name] = getOptionalStringValidator();
          }
          break;
        default:
      }
      return schema;
    }, {})
  );
};
